import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useInnerBlocks } from 'gutenberg/utils'
import ReactPlayer from 'react-player'

import { HeroBlockWrapper } from './custom.styled'

const HeroStage = props => {
  const { InnerBlocks } = useInnerBlocks(props.children, 'div', {
    className: `hero-stage__content--text ${
      props.rightImage?.url ? 'half' : 'full'
    }`,
  })
  const [videoUrl, setVideoUrl] = useState(null)

  //set video full url string
  const setVideoUrlString = video => {
    switch (props.videoType) {
      case 'youtube':
        setVideoUrl(
          `https://www.youtube.com/watch?v=${video}&controls=0&loop=1`
        )
        break
      case 'vimeo':
        setVideoUrl(`https://vimeo.com/${video}`)
        break
      default:
        setVideoUrl(video)
    }
  }

  //update video
  useEffect(() => {
    setVideoUrlString(props?.video)
  }, [props.videoType, props.video])

  return (
    <HeroBlockWrapper
      {...(props.anchor && { id: props.anchor })}
      className={['hero-stage', props.cssClass, props.style, 'alignfull']
        .filter(item => item)
        .join(' ')}
      style={
        props.image?.url && {
          backgroundImage: 'url(' + props.image.url + ')',
        }
      }
      background={props.background}
      white={props.whiteText}
      isEditor={props.isEditor}
      textImage={
        props.style == 'background-text' && props.textImage?.url
          ? props.textImage.url
          : null
      }
    >
      {props.video && videoUrl && (
        <div className={`player-wrapper${props.videoSize ? ' is-small' : ''}`}>
          <ReactPlayer
            className="react-player"
            width={'auto'}
            height={'auto'}
            url={videoUrl}
            playing={true}
            loop={true}
            controls={false}
            playsinline={true}
            volume={0}
            muted={true}
          />
        </div>
      )}
      <div className={'hero-stage__content'}>
        {InnerBlocks}
        {props.rightImage?.url && (
          <div className={'hero-stage__content--image'}>
            <img src={props.rightImage.url} alt="image" />
          </div>
        )}
      </div>
    </HeroBlockWrapper>
  )
}

HeroStage.propTypes = {
  isMobile: PropTypes.bool,
  isEditor: PropTypes.bool,
  whiteText: PropTypes.bool,
  videoSize: PropTypes.bool,
  style: PropTypes.string,
  children: PropTypes.any,
  background: PropTypes.string,
  anchor: PropTypes.string,
  image: PropTypes.object,
  rightImage: PropTypes.object,
  textImage: PropTypes.object,
  cssClass: PropTypes.string,
  videoType: PropTypes.string,
  video: PropTypes.string,
}

export default HeroStage
